module.exports = __webpack_public_path__ + "img/platform-logo-VeoliaApac.d8e6a82f.png";